import { coreClientAudioApi } from '../api/core/slice';

export const useClientAudioById = (clientId: number | undefined) => {
  const { data: audioFiles, isLoading, error } = coreClientAudioApi.useGetClientAudioByIdQuery(
    { clientId: clientId! },
    { skip: !clientId }
  );

  return {
    audioFiles: audioFiles || [],
    isLoading,
    error,
    hasAudio: audioFiles && audioFiles.length > 0,
    firstAudio: audioFiles?.[0],
  };
};
